import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";
import pageRoutes from './sisPageRoutes';

Vue.use(VueRouter);


const router = new VueRouter({
  routes:[].concat(pageRoutes),
});

function handleBreadCrumbsData(to, from, next) {
  /**
   * to create dynamic breadcrumbs
   * vue router's route will have matched property which we can use.
   * with every route we will keep pushing all the paths from matched object
   * to breadcrumbs property which we have assosciated with every route.
   */
  if (to.matched.length) {
    let tempBreadcrumbs = [];
    to.matched.forEach((route) => {
      if (route.meta.title) {
        tempBreadcrumbs.push({
          title: route.meta.title,
          url: route.path,
        });
      }
    });
    to.meta.breadcrumbs = tempBreadcrumbs.reverse();
  }
  /**
   * filter and remove the duplicate routes if there are any.
   */
  const titles = to.meta.breadcrumbs.map(({ title }) => title);
  let res = to.meta.breadcrumbs.filter(
    ({ title }, index) => !titles.includes(title, index + 1)
  ); // remove duplicates
  to.meta.breadcrumbs = res;
  next();
}

router.beforeEach((to, from, next) => {
  handleBreadCrumbsData(to, from, next);
  store.dispatch("setPageTitleAction", {
    title: to.meta.title,
    url: to.path,
    breadcrumbs: to.meta.breadcrumbs,
  });
  if (store.getters["menus/getMenus"].length) {
    if (
      !store.getters["menus/getMenus"].includes(to.path) &&
      to.meta?.checkAuth
    ) {
      next({ name: "unauthorized" });
    } else if (to.matched.length === 0) next({ name: "notFound" });
    else next();
  } else next();
});
export default router;
